import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../../components/DynamicSkeleton"

const columnConfig = {
  "Client ID": { content: <Skeleton height="20px" width="80px" />, center: true },
  "Client Name": { content: <Skeleton height="20px" width="140px" />, center: true },
  "Assigned Stations": {
    content: <Skeleton height="20px" width="180px" />,
    center: true,
  },
  Status: { content: <Skeleton height="20px" width="90px" />, center: true },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const FleetClientManagementSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default FleetClientManagementSkeleton
